import { render } from "./AdminPendingVideos.vue?vue&type=template&id=1beb2dee&scoped=true"
import script from "./AdminPendingVideos.vue?vue&type=script&lang=js"
export * from "./AdminPendingVideos.vue?vue&type=script&lang=js"

import "./AdminPendingVideos.vue?vue&type=style&index=0&id=1beb2dee&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3966428095/src/eelam-tv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1beb2dee"]])

export default __exports__